module.exports = __webpack_public_path__ + "static/media/wew.54e9d41c.svg";